import ReactDOM from 'react-dom/client';
import './styles/general.css';
import './styles/theme.css';
import App from './App';
import { BrowserRouter } from "react-router-dom";
import { Analytics } from '@vercel/analytics/react'; // 👈 1. استيراد Analytics

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
    <Analytics /> {/* 👈 2. إضافتها هنا */}
  </BrowserRouter>
);